export const PHARMACIES_MAX_SEARCH_DISTANCE_METERS = 10000;
export const PHARMACIES_LATITUDE = 50.4504;
export const PHARMACIES_LONGITUDE = 30.5245;
export const NO_PRESCRIPTION_GUID = '00000000-0000-0000-0000-000000000000';
